"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFabricStopScheduleOptions = exports.StopApi = exports.VehicleMode = void 0;
const objects_1 = require("./objects");
var VehicleMode;
(function (VehicleMode) {
    VehicleMode["bus"] = "bus";
    VehicleMode["tram"] = "tram";
    VehicleMode["subway"] = "subway";
    VehicleMode["rail"] = "rail";
    VehicleMode["ferry"] = "ferry";
})(VehicleMode = exports.VehicleMode || (exports.VehicleMode = {}));
var StopApi;
(function (StopApi) {
    StopApi["hsl"] = "hsl";
})(StopApi = exports.StopApi || (exports.StopApi = {}));
exports.isFabricStopScheduleOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === objects_1.ObjectType.CustomStopSchedule;
//# sourceMappingURL=stopSchedule.js.map